import {
  SITE_CONFIG_REQUEST,
  SITE_CONFIG_SUCCESS,
  SITE_CONFIG_FAILURE,
  SITE_CONFIG_UNLICENSED,
  AUTH_STATE_REQUEST,
  AUTH_STATE_SUCCESS,
  AUTH_STATE_FAILURE,
  AUTH_STATE_UNAUTHORISED,
  SET_AUTH_STATE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REMEMBER_PATH_BEFORE_LOGIN,
  RESTORE_PATH_AFTER_LOGIN,
  RESET_AUTH_ERROR,
  LOGOUT_SUCCESS,
  USER_CONFIG_REQUEST,
  USER_CONFIG_SUCCESS,
  USER_CONFIG_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  OPEN_PASSWORD_CHANGE_MODAL,
  CLOSE_PASSWORD_CHANGE_MODAL,
  FAILED_PASSWORD_CHANGE_MODAL,
  UPDATE_SELECTED_CLIENT,
  getStorageSetting,
  getStorageKey,
  GET_PII_VALIDATION_CODES_REQUEST,
  GET_PII_VALIDATION_CODES_SUCCESS,
  GET_PII_VALIDATION_CODES_FAILURE
} from 'actions';

import { SiteReadyState, AuthMode, AuthState } from 'actions/auth/common';

// eslint-disable-next-line default-param-last
function auth(state = {
  siteReady: SiteReadyState.Unknown,
  authMode: AuthMode.Manual,
  authState: AuthState.Unknown,
  sessionAuthMode: AuthMode.Manual,
  isFetching: false,
  isFetchingUserConfig: false,
  isAuthenticated: !!getStorageKey(),
  token: getStorageKey(),
  username: getStorageSetting('username'),
  settings: getStorageSetting(),
  permissions: getStorageSetting('permissions'),
  changePasswordError: null,
  piiValidationCodes: null
}, action) {
  switch (action.type) {
    case SITE_CONFIG_REQUEST:
      return {
        ...state,
        siteReady: SiteReadyState.GettingState,
        authMode: AuthMode.Manual,
      };
    case SITE_CONFIG_SUCCESS:
      return {
        ...state,
        siteReady: SiteReadyState.Ready,
        authMode: action.authMode,
        authState: action.authState
      };
    case SITE_CONFIG_FAILURE:
      return {
        ...state,
        siteReady: SiteReadyState.Down,
        authMode: AuthMode.Manual,
        authState: AuthState.Unknown
      };
    case SITE_CONFIG_UNLICENSED:
      return {
        ...state,
        siteReady: SiteReadyState.Unlicensed,
        authMode: AuthMode.Manual,
        authState: AuthState.Unknown
      };
    case AUTH_STATE_REQUEST:
      return {
        ...state,
        authState: AuthState.Requesting
      };
    case AUTH_STATE_SUCCESS:
      return {
        ...state,
        authState: AuthState.Known,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        sessionAuthMode: action.sessionAuthMode,
        token: action.token
      };
    case AUTH_STATE_FAILURE:
      return {
        ...state,
        authState: AuthState.Known
      };
    case AUTH_STATE_UNAUTHORISED:
      return {
        ...state,
        authState: AuthState.Unauthorised
      };
    case SET_AUTH_STATE:
      return {
        ...state,
        authState: action.state
      };
    case UPDATE_SELECTED_CLIENT:
      return {
        ...state,
        settings: action.settings,
        permissions: action.permissions
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching,
        isFetchingUserConfig: action.isFetchingUserConfig,
        isAuthenticated: action.isAuthenticated,
        username: action.username,
        errorMessage: action.errorMessage
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        sessionAuthMode: AuthMode.Manual,
        authState: AuthState.Known,
        token: action.token
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        username: action.username,
        token: action.token,
        errorMessage: action.errorMessage
      };
    case REMEMBER_PATH_BEFORE_LOGIN:
      return {
        ...state,
        restorePath: action.restorePath
      };
    case RESTORE_PATH_AFTER_LOGIN:
      return {
        ...state,
        restorePath: action.restorePath
      };
    case RESET_AUTH_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        permissions: null,
        settings: null,
        sessionAuthMode: AuthMode.Manual,
        authState: AuthState.LoggedOut
      };
    case USER_CONFIG_REQUEST:
      return {
        ...state,
        isFetchingUserConfig: true,
      };
    case USER_CONFIG_SUCCESS:
      return {
        ...state,
        isFetchingUserConfig: false,
        settings: action.settings,
        permissions: action.permissions,
        username: action.username,
        siteReady: action.noActiveClients ? SiteReadyState.NoClients : SiteReadyState.Ready,
      };
    case USER_CONFIG_FAILURE:
      return {
        ...state,
        isFetchingUserConfig: false,
        siteReady: SiteReadyState.Down,
        settings: {
          showBatches: false,
          showOngoingMonitoring: false,
          showCustomerOnboarding: false,
          showDigitalEntry: false,
          showJointAccounts: false,
          showScannedForms: false,
          showWithholding: false,
        },
        permissions: null
      };
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePasswordError: null
      };
    case FAILED_PASSWORD_CHANGE_MODAL:
      return {
        ...state,
        isPasswordChangeModalShown: action.isPasswordChangeModalShown,
        changePasswordError: action.changePasswordError
      };
    case OPEN_PASSWORD_CHANGE_MODAL:
      return {
        ...state,
        isPasswordChangeModalShown: action.isPasswordChangeModalShown,
        changePasswordError: null
      };
    case CLOSE_PASSWORD_CHANGE_MODAL:
      return {
        ...state,
        isPasswordChangeModalShown: action.isPasswordChangeModalShown,
        changePasswordError: null
      };
    case GET_PII_VALIDATION_CODES_REQUEST:
      return {
        ...state,
        isLoadingPiiValidationCodes: true
      };
    case GET_PII_VALIDATION_CODES_SUCCESS:
      return {
        ...state,
        isLoadingPiiValidationCodes: false,
        piiValidationCodes: action.piiValidationCodes
      };
    case GET_PII_VALIDATION_CODES_FAILURE:
      return {
        ...state,
        isLoadingPiiValidationCodes: false
      };
    default:
      return state;
  }
}

export default auth;
